import Promise from 'bluebird';
import { stringifySync } from '@bingads-webui/safe-json';

import { SelectorDataSource } from './selector-data-source';

export function formatKeywordName({ keywordName }) {
  return keywordName;
}

function getEncodeDataFunction() {
  return ({
    Id,
    Name,
    CampaignName,
    CampaignId,
    AdGroupName,
    AdGroupId,
  }) => {
    // overwrite the current scope campaignName when encoding filter values set in a different scope
    const campaignNameToUse = CampaignName;
    const campaignIdToUse = CampaignId;
    const adGroupNameToUse = AdGroupName;
    const adGroupIdToUse = AdGroupId;

    const newId = stringifySync({
      Id,
      Name,
      AdGroupName: adGroupNameToUse,
      AdGroupId: adGroupIdToUse,
      CampaignName: campaignNameToUse,
      CampaignId: campaignIdToUse,
    });

    return {
      Id: newId,
      Name: formatKeywordName({ keywordName: Name }),
    };
  };
}
export class KeywordDataSource {
  constructor() {
    this.selectorDataSource = new SelectorDataSource({
      encodeData: getEncodeDataFunction(),
    });
  }

  get itemsDisplayLimit() {
    return this.selectorDataSource.itemsDisplayLimit;
  }

  get() {
    // fetching of keyword ids for manual filter creation is not a supported scenario
    return Promise.resolve([]);
  }

  getByIds(ids) {
    return this.selectorDataSource.getByIds(ids);
  }
}
